import axios_ from "../utils/axios";

export default {
  templateStore(param) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/templates/${param.id ? "uptStore" : "store"}`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getTemplates(param) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/templates/lists`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getTemplateInfo(param) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/templates/detail`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  templateDelete(param) {
    return new Promise((resolve, reject) => {
      axios_("post", `api/pandagpt/v1/templates/del`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  templateUsedList(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/templates/useLists`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
};
